import React, { useState} from 'react';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import KlijentiUnos from './KlijentiTabs/KlijentiUnos';
import KlijentiPregled from './KlijentiTabs/KlijentiPregled';
import BonitetProvera from './KlijentiTabs/BonitetProvera';
import { useSelector } from 'react-redux';

const KlijentiHome = () => {
  const { t } = useTranslation();

    const [changeView, setChangeView] = useState(4);
    const activeClass = 'activeButton'
    const [bonitetData, setBonitetData] = useState(null);
    const company = useSelector(state => state.company)

return (
    <div style={{marginTop:'1%'}}>
        <Button id={changeView == 1 && activeClass} label={t('fakture.pregled')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(1)} } />
        <Button id={changeView == 2 && activeClass} label={t('admin.pregledNbs')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(2)} } />
        <Button id={changeView == 3 && activeClass} label={t('admin.pregledApr')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(3)} } />
        <Button id={changeView == 4 && activeClass} label={t('admin.unos')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(4)} } />
        {['DOO ŠARČEVIĆ CO VRBAS','DMDS DOO   ŠKOFLJICA (SI)','AVD COMPANY d.o.o'].includes(company.companyName) && <Button id={changeView == 5 && activeClass} label={t('admin.bonitet')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(5)} } />}
    
        {(changeView == 1  || changeView == 2 || changeView == 3 )  &&  <KlijentiPregled changeView={changeView}/>}
        {changeView == 4 && <KlijentiUnos bonitetData={bonitetData} setBonitetData={setBonitetData}/>}
        {changeView == 5 && <BonitetProvera setChangeView={setChangeView} setBonitetData={setBonitetData}/>}
    </div>
)
}

export default KlijentiHome;